import React, { useEffect } from "react";
import "./assest_design/Contact.css";

export default function Contact() {
  useEffect(() => {
    document.title =
      "Contact ProCode ZA | Software & App Development Company in South Africa";

    const setMeta = (name, content, property = false) => {
      const selector = property
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;

      let tag = document.querySelector(selector);

      if (!tag) {
        tag = document.createElement("meta");
        if (property) {
          tag.setAttribute("property", name);
        } else {
          tag.setAttribute("name", name);
        }
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Contact ProCode ZA for custom software development, app development, website development, AI solutions, automation systems, branding, dashboards, IoT projects and technical support in Johannesburg, Cape Town, Durban and across South Africa."
    );
    setMeta(
      "keywords",
      "software development company South Africa, app development South Africa, website development South Africa, Johannesburg software company, Cape Town app developers, Durban software developers, AI development South Africa, dashboard development South Africa, branding services South Africa, ProCode ZA contact"
    );
    setMeta(
      "og:title",
      "Contact ProCode ZA | Software, Apps, Websites, AI and Support in South Africa",
      true
    );
    setMeta(
      "og:description",
      "Speak to ProCode ZA about custom software, app development, websites, AI, branding, IoT, automation, dashboards and long-term support for businesses in Johannesburg, Cape Town, Durban and across South Africa.",
      true
    );
    setMeta("og:type", "website", true);
  }, []);

  return (
    <div className="contact-page">
      {/* HERO */}
      <section className="contact-hero">
        <span className="contact-badge">Let’s Talk</span>

        <h1>Get in Touch</h1>

        <p className="contact-subtitle">
          Speak to ProCode ZA about custom software development, app
          development, websites, dashboards, AI solutions, branding,
          automation, IoT projects and technical support in Johannesburg, Cape
          Town, Durban and across South Africa. Tell us what you need built,
          improved or fixed and we’ll help you identify the smartest next step.
        </p>
      </section>

      {/* CONTENT */}
      <section className="contact-content">
        {/* LEFT INFO */}
        <div className="contact-info">
          <h2>Why reach out to ProCode?</h2>

          <p className="contact-intro">
            We work with businesses, institutions and growing teams across South
            Africa that need more than just a basic developer. Whether you need
            a custom business system, a premium website, an AI or automation
            solution, help with branding, or urgent changes to an existing
            platform, ProCode ZA is built to deliver practical, high-quality
            digital solutions with long-term value.
          </p>

          <ul>
            <li>✔ Speak directly to real engineers and solution builders</li>
            <li>✔ We adopt, improve and maintain existing systems</li>
            <li>✔ Clear pricing and practical scoping</li>
            <li>✔ Long-term support through the Pod Programme</li>
            <li>✔ Websites, software, AI, dashboards, branding and IoT support</li>
          </ul>

          <div className="contact-trust">
            <p>Most clients contact us when:</p>
            <span>
              “Our developer disappeared.”<br />
              “We need urgent changes.”<br />
              “We want this done properly.”<br />
              “We need a team that can actually support growth.”
            </span>
          </div>

          <div className="contact-price-match">
            <h3>Already have a quote from another business?</h3>
            <p>
              Attach the quotation when you contact us. If you already have a
              quote from another provider, we’ll review it and where possible
              <strong> match or beat the price</strong> while still delivering
              strong quality, clarity and long-term value.
            </p>
          </div>

          {/* SOCIALS + PHONE */}
          <div className="contact-socials">
            <h3>Connect with us</h3>

            <a
              href="https://www.linkedin.com/company/procode-za"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6C1.12 6 0 4.88 0 3.5C0 2.12 1.12 1 2.5 1C3.87 1 4.98 2.12 4.98 3.5ZM0.5 8H4.5V24H0.5V8ZM8 8H11.8V10.2H11.85C12.38 9.2 13.7 8.15 15.65 8.15C19.7 8.15 20.5 10.8 20.5 14.25V24H16.5V15.3C16.5 13.25 16.45 10.6 13.65 10.6C10.8 10.6 10.35 12.8 10.35 15.15V24H6.35V8H8Z"
                  fill="currentColor"
                />
              </svg>
              LinkedIn
            </a>

            <a
              href="https://www.instagram.com/procodeza"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M7 2C4.24 2 2 4.24 2 7V17C2 19.76 4.24 22 7 22H17C19.76 22 22 19.76 22 17V7C22 4.24 19.76 2 17 2H7ZM20 17C20 18.65 18.65 20 17 20H7C5.35 20 4 18.65 4 17V7C4 5.35 5.35 4 7 4H17C18.65 4 20 5.35 20 7V17ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15ZM18 6.5C18 7.33 17.33 8 16.5 8C15.67 8 15 7.33 15 6.5C15 5.67 15.67 5 16.5 5C17.33 5 18 5.67 18 6.5Z"
                  fill="currentColor"
                />
              </svg>
              Instagram
            </a>

            <div className="contact-phones">
              <p>
                <strong>Pod Support:</strong>{" "}
                <a href="tel:+27717158000">+27 71 715 8000</a>
              </p>
              <p>
                <strong>Reception:</strong>{" "}
                <a href="tel:+27710762247">071 076 2247</a>
              </p>
              <p>
                <strong>WhatsApp:</strong>{" "}
                <a
                  href="https://wa.me/27785888562"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  078 588 8562
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* FORM */}
        <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
          <h3>Send us a message</h3>

          <label>
            Name
            <input type="text" placeholder="Your name" />
          </label>

          <label>
            Email
            <input type="email" placeholder="you@email.com" />
          </label>

          <label>
            Company / Organisation
            <input type="text" placeholder="Your business or organisation name" />
          </label>

          <label>
            What can we help you with?
            <textarea
              rows="4"
              placeholder="Tell us about your website, software project, app idea, support issue, AI solution, branding request, dashboard, IoT build or anything else you need..."
            />
          </label>

          <label>
            Attach competitor quote or supporting file
            <input type="file" />
          </label>

          <button type="submit" className="contact-submit">
            Send Message
          </button>

          <p className="contact-note">
            Have a quote from another provider? Attach it and we’ll review it to
            see where we can match or beat the price.
          </p>
        </form>
      </section>
    </div>
  );
}